
import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Plus, RefreshCw, BookOpen } from "lucide-react";
import { format } from "date-fns";

interface SermonHeaderProps {
  nextAutoGenerationDate: Date;
  onAddNew: () => void;
  onGenerate: () => void;
}

export function SermonHeader({ nextAutoGenerationDate, onAddNew, onGenerate }: SermonHeaderProps) {
  return (
    <>
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
          Manage Sermon Plans
        </h1>
        <div className="flex flex-col sm:flex-row gap-3">
          <div className="bg-yellow-50 border border-yellow-200 rounded-md px-4 py-2 flex items-center">
            <RefreshCw className="h-4 w-4 text-yellow-500 mr-2 animate-spin-slow" />
            <div>
              <p className="text-sm text-yellow-700">Next auto-generation:</p>
              <p className="text-xs font-medium text-yellow-800">
                {format(nextAutoGenerationDate, "EEEE, MMMM d 'at' h:mm a")}
              </p>
            </div>
          </div>
          <div className="flex gap-2">
            <Button 
              variant="secondary" 
              className="flex-shrink-0"
              onClick={onGenerate}
            >
              <RefreshCw className="mr-2 h-4 w-4" /> Generate Now
            </Button>
            <Button onClick={onAddNew} className="flex-shrink-0">
              <Plus className="mr-2 h-4 w-4" /> Add Plan
            </Button>
          </div>
        </div>
      </div>

      <Card className="mb-6 bg-blue-50 border-blue-200">
        <CardContent className="p-4">
          <div className="flex items-start">
            <BookOpen className="h-8 w-8 text-blue-500 mr-3 mt-1" />
            <div>
              <h3 className="font-medium text-blue-700 mb-1">Automated Sermon Plans</h3>
              <p className="text-sm text-blue-600">
                Every Friday at 5:00 PM, the system analyzes journal entries from your congregation 
                and automatically generates sermon plan ideas based on common themes, concerns, and spiritual needs.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </>
  );
}
